/****************************************************************************
 Copyright (c) 2013-2016 Chukong Technologies Inc.
 Copyright (c) 2017-2018 Xiamen Yaji Software Co., Ltd.

 https://www.cocos.com/

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated engine source code (the "Software"), a limited,
  worldwide, royalty-free, non-assignable, revocable and non-exclusive license
 to use Cocos Creator solely to develop games on your target platforms. You shall
  not use Cocos Creator software for developing other software or tools that's
  used for developing games. You are not granted to publish, distribute,
  sublicense, and/or sell copies of Cocos Creator.

 The software or tools in this License Agreement are licensed, not sold.
 Xiamen Yaji Software Co., Ltd. reserves all rights not expressly granted to you.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 ****************************************************************************/

/**
 * Class for tiled map asset handling.
 * @class TiledMapAsset
 * @extends Asset
 *
 */
let TiledMapAsset = cc.Class({
    name: 'cc.TiledMapAsset',
    extends: cc.Asset,

    properties: {
        tmxXmlStr: '',

        /**
         * @property {Texture2D[]} textures
         */
        textures: {
            default: [],
            type: [cc.Texture2D]
        },

        /**
         * @property {String[]} textureNames
         */
        textureNames: [cc.String],

        /**
         * @property {Size[]} textureSizes
         */
        textureSizes: {
            default: [],
            type: [cc.Size]
        },

        /**
         * @property {Texture2D[]} imageLayerTextures
         */
        imageLayerTextures: {
            default: [],
            type: [cc.Texture2D]
        },

        /**
         * @property {String[]} imageLayerTextureNames
         */
        imageLayerTextureNames: [cc.String],

        tsxFiles: [cc.TextAsset],
        tsxFileNames: [cc.String],
    },

    statics: {
        preventDeferredLoadDependents: true
    },

    createNode: CC_EDITOR && function (callback) {
        let node = new cc.Node(this.name);
        let tiledMap = node.addComponent(cc.TiledMap);
        tiledMap.tmxAsset = this;

        return callback(null, node);
    }
});

cc.TiledMapAsset = TiledMapAsset;
module.exports = TiledMapAsset;
